import React, { useRef } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDStack } from '@facet-wealth/design';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { QuizWrapperLayout } from 'Views/FreemiumEntry/HasRelationship/Content/Components/QuizWrapperLayout';
import useMobileLayout from 'Hooks/useMobileLayout';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  InfluencerHeadshotAndDetails,
  ContactForm,
  InfluencerDescription,
  InsightCTASection,
  FeaturedInWidget,
  InterstitialHeadline,
  CompareFacetSections,
  IndustryExperts,
  USATodayWidget,
  ContentWrapper, MemberTestimonials,
  Footer,
} from './Components';


export const InfluencerLayout = ({ handleSubmit, handleLowerCTAClicked, showContactForm = true }) => {
  const {
    resource, saving,
  } = useMetaLayoutContext();
  useBoneBackgroundColor();
  useScrollTopOnMount();
  const isMobile = useMobileLayout();

  const contactFormRef = useRef(null);

  const isInsight = resource.meta().type() === 'FQResponseInsightInfluencer';
  let topSectionStackDirection = isMobile ? 'column' : 'row';
  let topSectionAlignItems = isMobile ? 'center' : 'flex-start';
  if (isInsight) {
    topSectionStackDirection = 'column';
    topSectionAlignItems = 'center';
  }

  return (
    <>
      <QuizWrapperLayout maxWidth={'xl'} bottomSpacing={false}>
        <FDStack direction={topSectionStackDirection} spacing={4} wrap justifyContent={'center'} alignItems={topSectionAlignItems}>
          <InfluencerHeadshotAndDetails />
          {isInsight
            ? <InsightCTASection handleSubmit={handleSubmit} />
            : <ContactForm handleSubmit={handleSubmit} saving={saving} ref={contactFormRef} showContactForm={showContactForm} />}
          <InfluencerDescription />
        </FDStack>
        <FDStack direction={'column'} spacing={isMobile ? 6 : 8} justifyContent={'center'}>
          <FeaturedInWidget />
          <InterstitialHeadline showFac titles={resource.attr('influencerCompareFacetSectionTitles')} />
          <CompareFacetSections />
          <InterstitialHeadline titles={[resource.attr('influencerExpertsSectionTitle')]} />
        </FDStack>
      </QuizWrapperLayout>
      {/* Industry experts section, full width */}
      <IndustryExperts />
      <ContentWrapper>
        <FDStack maxWidth={'700px'}>
          <MetaControlField attr={'influencerExpertTestimonialDisclosure'} align={'center'} />
        </FDStack>
      </ContentWrapper>
      {/*  Member testimonials, full width */}
      <MemberTestimonials handleSubmit={handleLowerCTAClicked} />
      <ContentWrapper>
        {resource.attr('influencerQuote') && <InterstitialHeadline titles={[resource.attr('influencerQuote')]} size={'md'} showFac /> }
        <USATodayWidget />
      </ContentWrapper>
      {/*  Footer, full width */}
      <Footer />
    </>
  );
};
